import { render, staticRenderFns } from "./MatchStats.vue?vue&type=template&id=81f154f4&scoped=true&"
import script from "./MatchStats.vue?vue&type=script&lang=js&"
export * from "./MatchStats.vue?vue&type=script&lang=js&"
import style0 from "./MatchStats.vue?vue&type=style&index=0&id=81f154f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f154f4",
  null
  
)

export default component.exports